import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ChevronRight, Home } from 'lucide-react';

const SITE = 'https://www.maderaselocote.com';

/**
 * Migas de pan. Ademas de la navegacion visible emite el BreadcrumbList de
 * schema.org, para que Google y los motores de IA entiendan la jerarquia
 * del sitio sin duplicar la definicion en cada pagina.
 */
const Breadcrumbs = ({ items }) => {
  const itemList = [
    { name: 'Inicio', path: '/' },
    ...items.map((item) => ({ name: item.label, path: item.path })),
  ];

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: itemList.map((item, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: item.name,
              ...(item.path ? { item: `${SITE}${item.path === '/' ? '/' : item.path}` } : {}),
            })),
          })}
        </script>
      </Helmet>

      <nav aria-label="Ruta de navegación" className="flex flex-wrap items-center gap-2 text-sm text-wood-500 mb-8">
        <Link to="/" className="hover:text-wood-900 transition-colors duration-200 flex items-center" aria-label="Inicio">
          <Home className="w-4 h-4" />
        </Link>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <ChevronRight className="w-4 h-4 text-wood-300 flex-shrink-0" />
            {item.path ? (
              <Link to={item.path} className="hover:text-wood-900 transition-colors duration-200">
                {item.label}
              </Link>
            ) : (
              <span className="text-wood-900 font-medium" aria-current="page">{item.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>
    </>
  );
};

export default Breadcrumbs;
